import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Chip, IconButton, List, ListItem } from '@mui/material';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { backend } from '../axios/backend';
import PrettyLoader from '../components/PrettyLoader';
import UpsertTagModal from '../components/UpsertTagModal';
import { useAppContext } from '../context/AppContext';
import { useTags } from '../hooks/useTags';
import { parseErrorMessage } from '../utils/error-message';

const MyTagsPage = () => {
  const { alertError, alertSuccess } = useAppContext();
  const [isModalOpen, setModalOpen] = useState(false);

  const query = useTags();

  const deleteMutation = useMutation((id: string) => backend.delete(`tag/${id}`), {
    onSuccess: () => {
      query.refetch();
      alertSuccess('Tag gelöscht.');
    },
    onError: (e) => alertError(parseErrorMessage(e)),
  });

  return (
    <div style={{ margin: '2rem' }}>
      <h1>Meine Tags</h1>
      <PrettyLoader useQueryResult={query}>
        {query.data && (
          <>
            <List>
              {query.data.map((t) => (
                <ListItem
                  key={t._id.toString()}
                  secondaryAction={
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteMutation.mutate(t._id.toString());
                      }}
                      size="small"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  }
                >
                  <Chip label={t.name} style={{ backgroundColor: t.backgroundColor, color: t.color }} />
                </ListItem>
              ))}
              <Button onClick={() => setModalOpen(true)}>Tag hinzufügen</Button>
            </List>
            <UpsertTagModal isOpen={isModalOpen} setOpen={setModalOpen} tags={query.data} />
          </>
        )}
      </PrettyLoader>
    </div>
  );
};

export default MyTagsPage;
